module.exports = __webpack_public_path__ + "img/b-mask_banyai.a011a5e.png";